<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-6">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-6">
          <c-datepicker
            default="today"
            type="year"
            label="년도"
            name="year"
            v-model="searchParam.year"
          />
        </div>
        <!-- <div class="col-6">
          <c-select
            type="search"
            codeGroupCd="SOP_FIRE_FIGHTING_ISSUE_STEP_CD"
            itemText="stepperMstNm"
            itemValue="stepperMstCd"
            name="sopFireFightingIssueStepCd"
            label="진행상태"
            v-model="searchParam.sopFireFightingIssueStepCd"
          ></c-select>
        </div> -->
        <div class="col-12">
          <c-dept 
            :isFirstValue="false"
            type="search" 
            label="점검부서" 
            name="deptCd" 
            v-model="searchParam.deptCd" />
        </div>
      </template>
    </c-search-box>
    <q-table
      grid
      title=""
      :data="grid.data"
      :columns="grid.columns"
      hide-header
      hide-bottom
      :rows-per-page-options="[0]"
      virtual-scroll
    >
      <template v-slot:item="props">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3">
          <q-card class="mobileTableCardLayer" @click="linkClick(props.row)">
            <q-card-section class="grid-card-etc">
              <div :class="['text-grid-etc', 'txt-box-grid text-primary-box']">
                {{ props.row.sopFireFightingIssueStepName }}
              </div>
              <div :class="['text-grid-etc', 'txt-box-grid text-positive-box']">
                {{ props.row.deptName }}
              </div>
            </q-card-section>
            <q-card-section>
              <div class="text-grid-title q-mt-sm q-mb-xs">{{ props.row.issueCheckName }}</div>
            </q-card-section>
            <q-card-section class="grid-card-etc">
              <div class="text-grid-etc">
                {{ props.row.yearmonth }}
              </div>
            </q-card-section>
          </q-card>
        </div>
      </template>
    </q-table>
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3" v-if="grid.data.length === 0">
      <q-card class="mobileTableCardLayer">
        <q-card-section horizontal class="bg-grey-2 text-center">
          <q-card-section class="q-pt-xs">
            <div class="text-grid-title q-mt-sm q-mb-xs">데이터가 존재하지 않습니다.</div>
          </q-card-section>
        </q-card-section>
      </q-card>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'fireFightingIssueCheck',
  data() {
    return {
      searchParam: {
        plantCd: null,
        year: '',
        sopFireFightingIssueStepCd: 'MOBILE',
        deptCd: null,
      },
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            align: 'center',
            sortable: true,
            style: 'width: 100px',
          },
          {
            name: 'issueCheckName',
            field: 'issueCheckName',
            label: '점검명',
            align: 'left',
            sortable: true,
            style: 'width: 350px',
            type: 'link',
          },
          {
            name: 'yearmonth',
            field: 'yearmonth',
            label: '점검년월',
            align: 'center',
            sortable: true,
            style: 'width: 100px',
          },
          {
            name: 'deptName',
            field: 'deptName',
            label: '점검부서',
            align: 'center',
            sortable: true,
            style: 'width: 150px',
          },
          {
            name: 'sopFireFightingIssueStepName',
            field: 'sopFireFightingIssueStepName',
            label: '진행상태',
            align: 'center',
            sortable: true,
            style: 'width: 150px',
          },
        ],
        data: [],
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  beforeRouteLeave(to, from, next) { // history.back 일경우 팝업이라면 팝업을 닫자
    if (this.popupOptions.visible) {
      this.closePopup();
      next(false);
    } else {
      next();
    }
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.fft.fireFightingIssueCheck.list.url
      this.detailUrl = selectConfig.fft.fireFightingIssueCheck.getFireFighting.url
      // code setting
      if (this.$route.query.sopFireFightingId) {
        this.$http.url = this.$format(this.detailUrl, this.$route.query.sopFireFightingId);
        this.$http.type = 'GET';
        this.$http.param = {};
        this.$http.request((_result) => {
          if (_result.data) {
            _result.data.sopFireFightingId = this.$route.query.sopFireFightingId
            this.linkClick(_result.data);
          } else {
            window.getApp.$emit('ALERT', {
              title: '안내', 
              message: '해당 소방설비에 할당된 점검이 없습니다.',
              type: 'warning', // success / info / warning / error
            });
          }
        },);
      }
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(row) {
      this.popupOptions.title = '소방 이슈점검 상세';
      this.popupOptions.param = {
        sopFireFightingIssueCheckId: row ? row.sopFireFightingIssueCheckId : '',
        sopFireFightingId: row ? row.sopFireFightingId : '',
      };
      this.popupOptions.target = () => import(`${'./fireFightingIssueCheckDetail.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
